import tw from "./tw";

export default {
  tw
};
